import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source", "button"];

  declare readonly buttonTarget: HTMLElement;
  declare readonly sourceTarget: HTMLElement;

  #timer: any = null;

  copy() {
    this.#copyToClipboard(this.sourceTarget.innerText);
    this.buttonTarget.classList.add("fui-button--loading");
    if (this.#timer) clearTimeout(this.#timer);
    this.#timer = setTimeout(() => {
      this.buttonTarget.classList.remove("fui-button--loading");
    }, 1000);
  }

  #copyToClipboard(textToCopy: string) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(textToCopy);
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      textArea.style.position = "absolute";
      textArea.style.left = "-999999px";
      document.body.prepend(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
      } catch (error) {
        console.error(error);
      } finally {
        textArea.remove();
      }
    }
  }
}
